<template lang="pug">
.tableTop10-bottom
  .tableTop10-option2(v-if="identity !='partners'")
    .tableTop10-titleItem
      span 發布機關
    Dropdown(id="option" placeholder='請選擇' :selectText="selectText" :infos="infos" optionClass="tableTop10-publishOption" innerTextClass="tableTop10-innerText" @selectDropdown="selectDropdown")
  .tableTop10-option2(v-else)
    .tableTop10-titleItem
      span 已查核單位
    Dropdown(id="option" placeholder='請選擇' :selectText="selectText" :infos="infos" optionClass="tableTop10-publishOption" innerTextClass="tableTop10-innerText" @selectDropdown="selectDropdown")
  
  .tableTop10-calendar
    .tableTop10-calendar-block
      .tableTop10-datepicker
        .tableTop10-titleItem
          span 開始日期
        .tableTop10-date.other-date(id="date-picker-dropdownFilter" @click='clickDatePicker')
          span.tableTop10-innerText(v-if='!start') 請選擇日期
          span.tableTop10-innerText.color--black90(v-else) {{ getDateString(start) }}
          //- when active the icon class is .icon-fold
          i.icon-calendar.tableTop10-iconOption
      .tableTop10-datepicker
        .tableTop10-titleItem
          span 結束日期
        .tableTop10-date(id="date-picker-dropdownFilter2" @click='clickDatePicker')
          span.tableTop10-innerText(v-if='!end') 請選擇日期
          span.tableTop10-innerText.color--black90(v-else) {{ getDateString(end) }}
          //- when active the icon class is .icon-fold
          i.icon-calendar.tableTop10-iconOption
      div(:class='isMobile? "popup": ""' :style='pickdate? "": "display: none;"')
        .popup-overlay(v-if='isMobile')
        DatePicker(
          :startDate='startDate' @filter='filterWithRange' @select='dateSelect'
          @cancel='dateCancel'
          ref='datePicker'
          :date1='start ? start.toLocaleDateString() : ""'
          :date2='end ? end.toLocaleDateString() : ""'
          :header='isMobile? true: false'
          :popup='isMobile? true: false'
          :width="isMobile? '': '100%'"
          :top="isMobile? '': '80px'"
        )
  .tableTop10-flags(v-if="identity=='partners'")
    .tableTop10-titleItem
      span 類別
    .tableTop10-flagsWrapper
      div(v-for="category in staticData.categories" @click="selectCategoryBtn(category.id)")
        .tableTop10-flag--active(v-if="isActive[category.id]")
          span {{ category.name }}
        .tableTop10-flag(v-else)
          span {{ category.name }}
  .tableTop10-flags(v-if="identity=='partners'")
    .tableTop10-titleItem
      span 類型
    .tableTop10-flagsWrapper
      div(v-for="types in typeMap" @click="selectTypeBtn(types.id)")
        .tableTop10-flag--active(v-if="types.id == isTypeActive")
          span {{ types.zh_name }}
        .tableTop10-flag(v-else)
          span {{ types.zh_name }}

</template>
<script>
import DatePicker from "@/components/modules/date_picker/date_picker.vue";
import Dropdown from "@/components/modules/dropdown.vue";

import { getDateString, deviceType } from "@/plugins/tool.js";

export default {
  props: {
    staticData: Object,
    preGovId: Number,
    prePartnerId: Number,
    preGovName: String,
    preStart: Date,
    preEnd: Date,
    preSelectCategoryIds: String,
    preSelectType: String
  },
  components: {
    DatePicker,
    Dropdown,
  },
  data() {
    return {
      selectText: "",
      govId: null,
      partnerId: null,
      infos: [],
      pickdate: false,
      start: null,
      end: null,
      isActive: {},
      categoryMap: {},
      isTypeActive: 0,
      typeMap: [{id: 0, zh_name: "全部", en_name: "all"}, {id: 1, zh_name: "圖片", en_name: "image"}, {id: 2, zh_name: "文字", en_name: "text"}, {id: 3, zh_name: "語音", en_name: "audio"}],
      isMobile: false,
      startDate: this.$store.state.datePickerConfig.start,
      identity: localStorage.getItem(this.$store.state.storageKeys.identity),
    };
  },
  created() {
    this.getInfo();
    if (this.preGovId) this.govId = this.preGovId;
    if (this.prePartnerId) this.partnerId = this.prePartnerId;
    if (this.preGovName) this.selectText = this.preGovName;
    if (this.preStart) this.start = this.preStart;
    if (this.preEnd) this.end = this.preEnd;
    if (this.identity == "partners") {
      this.staticData.categories.forEach((category) => {
        this.isActive[category.id] = false;
        this.categoryMap[category.id] = category.name;
      });
      if (this.preSelectCategoryIds) {
        var keyList = this.preSelectCategoryIds.split("&categoryId=");
        keyList.forEach((key) => {
          this.isActive[key] = true;
        });
      }
      if(this.preSelectType){
        var keyTypeList = this.preSelectType.split("&type=")[0];
        this.typeMap.forEach((key) => {
          if(key.en_name === keyTypeList)
            this.isTypeActive = key.id;
        });
      }
    }
    this.checkMobile();
    window.onresize = this.checkMobile;
  },
  methods: {
    checkMobile() {
      this.isMobile = deviceType() === "mobile" || deviceType() === "tablet";
    },
    async getInfo() {
      let route = (this.identity === "government"
          ? this.$store.state.URLs.apiPartner
          : this.$store.state.URLs.api) +
        "/" +
        this.$store.state.lang + 
        (this.identity === "partners"
          ? this.$store.state.routes.partners          
          : this.$store.state.routes.govOption)

      const token = localStorage.getItem(this.$store.state.storageKeys.token);
      const headers = token ? { 'X-Line-Biz-Session': token } : {};
      const result = await this.$axios.get(route, { headers });

      this.infos = this.identity === "partners" ? result.data.content : result.data;
      this.infos.unshift({ id: 0, name: "全部", language: "zhtw" });
    },
    selectDropdown(event) {
      if(this.identity === "partners") {
        this.partnerId = event.id;
      } else {
        this.govId = event.id;
      }
      this.selectText = event.name;
    },
    filterWithRange(start, end) {
      this.dateSelect(start, end);
      this.pickdate = false;
    },
    clickDatePicker() {
      if (this.pickdate) {
        this.$refs.datePicker.cancel();
      } else {
        this.$refs.datePicker.focus();
        this.pickdate = true;
      }
    },
    selectTypeBtn(id) {
      this.isTypeActive = id;
      this.$forceUpdate();
    },
    selectCategoryBtn(id) {
      this.isActive[id] = !this.isActive[id];
      this.$forceUpdate();
    },
    getDateString(date) {
      return getDateString(date);
    },
    dateSelect(start, end) {
      this.start = start;
      this.end = end;
    },
    dateCancel(start, end) {
      this.start = start;
      this.end = end;
      this.pickdate = false;
    },
    clear() {
      this.govId = null;
      this.partnerId = null;
      this.selectText = "";
      this.start = null;
      this.end = null;
      for (var key in this.isActive) {
        this.isActive[key] = false;
      }
      this.$forceUpdate();
    },
  },
};
</script>
<style scoped>
.color--black90 {
  color: black;
}
.tableTop10-calendar-block {
  position: relative;
}
</style>
